<div class="terms-main">
  <div class="col-lg-12 row">
    <div class="col-lg-1"></div>
    <div class="col-lg-10">
      <div class="text-center heading-main p-3">TERMS OF USE </div>
      <div class="risk-data">
        <div class="heading-sub  pt-3 pl-3">
          LEGAL NOTICE
        </div>
        <div class="risk-content p-3">
          <p>Visitors to this web site are bound by the following terms and conditions. ('Terms') please read this
            document carefully before continuing to use this site. If you do not agree with any of these terms, please
            do not use this site. If you have any queries about these terms, please contact mfassist&#64;itiorg.com

          </p>
          <p>Although ITI Asset Management Limited ('ITIAML') tries to ensure that all information and recommendations,
            whether in relation to the products, services, offerings or otherwise (hereinafter 'Information') provided
            as part of this website is correct at the time of its inclusion on the web site, ITIAML does not guarantee
            the accuracy of the Information. ITIAML makes no representations or warranties as to the completeness or
            accuracy of the Information or its utility for a particular purpose or for specific result.

          </p>
          <ul>
            <li>ITIAML makes no commitment to update or correct any Information that appears on the Internet or on this
              web site.
            </li>
            <li>
              Information is supplied upon the condition that the persons receiving the same will make their own
              determination as to its suitability for their purposes prior to use or in connection with the making of
              any
              decision. No Information at this web site shall constitute an invitation to invest in ITIAML or any of its
              affiliates. Any use of this website or the Information it contains is at your own risk. Neither ITIAML and
              ITIAML affiliates, nor their officers, employees or agents shall be liable for any loss, damage or expense
              arising out of any access to, use of, or ITIAML upon, this website or the Information, or any website
              linked
              to this website.

            </li>
            <li>
              Nothing contained herein is to be construed as a recommendation to use any product, process, equipment or
              formulation, in conflict with any patent, or otherwise and ITIAML makes no representation or warranty,
              express or implied that, the use thereof will not infringe any patent, copyright or any other intellectual
              or property rights of any third party or otherwise.

            </li>
          </ul>
          <!-- </div> -->
          <p>This website is provide to you on an "As Is" And "Where-Is" basis, without any warranty. Itiaml, for itSelf
            and any third party providing materials, services, Or content to this website, makes no representations Or
            warranties, either expressed, implied, statutory Or otherwise Of merchantability, fitness for a particular
            purpose, Or non-infrigement Of third party rights, with respect to the website, the information Or any
            products Or services to which the information refers. Itiaml will not be liable to you Or any third party
            for any damages Of any kind, including but not limited to, direct, indirect, incidental, consequential Or
            punitive damages, arising from Or connected with the site, including but not limited to, your use Of this
            site Or your inability to use the site, even if Itiaml has previously been advised of the possibility of
            such damages.


          </p>
        </div>
      </div>

      <div class="heading-sub  pt-3 pl-3">
        ITI Asset Management Limited

      </div>
      <div class="heading-sub2  pt-3 pl-3">
        Disclaimer

      </div>
      <div class="risk-content p-3">
        <p>ITIAML has its own separate identity but in this web site we may sometimes use 'ITI Group Company', 'we' or
          'us' when we refer to ITIAML company in general or where no useful purpose is served by identifying any
          particular ITIAML company.

        </p>
        <p>Mutual fund investments are subject to market risks. Read all scheme related documents carefully.

        </p>

      </div>
      <div class="heading-sub2  pt-3 pl-3">
        Availability

      </div>
      <div class="risk-content li-data2">
        <ul>
          <li>ITIAML controls and operates this web site from India and makes no representation that the materials are
            appropriate or will be available for use in other locations. If you use this web site from outside India,
            you
            are entirely responsible for compliance with all applicable local laws.
          </li>
          <li>In case ITIAML has or develops more than one website offering products, services, content and various
            other
            functionalities (collectively the 'Services') to specific regions worldwide. The Services offered in one
            region may differ from those in other regions due to availability, local or regional laws, shipment and
            other
            considerations. ITIAML does not make any warranty or representation that a user in one region may obtain the
            Services from the ITIAML site in another region and ITIAML may cancel a user's order or redirect a user to
            the
            site for that user's region if a user attempts to order Services offered on a site in another region.
          </li>
          <li>Information that ITIAML publishes on the World Wide Web may contain references or cross references to
            ITIAML
            products, programs and services that are not announced or available in your country. Such references do not
            imply that ITIAML intends to announce such products, programs or services in your country. Consult your
            local
            ITIAML business contact for information regarding the products, programs and services that may be available
            to
            you.
          </li>
          <li>Nothing contained herein is to be construed as a recommendation to use any product, process, equipment or
            formulation, in conflict with any patent, or otherwise and ITIAML makes no representation or warranty,
            express
            or implied that, the use thereof will not infringe any patent, or otherwise.
          </li>
        </ul>

      </div>
      <div class="heading-sub2  pt-3 pl-3">
        Copyrights

      </div>
      <div class="risk-content li-data2">
        <ul>
          <li>
            This web site contains material, including text, graphics and sound, which is protected by copyright and/or
            other intellectual property rights. All copyright and other intellectual property rights in this material
            are
            either owned by ITIAML or have been licensed to ITIAML by the owner(s) of those rights so that it can use
            this
            material as part of this web site. ITIAML retains copyright on all Information, including text, graphics and
            sound and all trademarks displayed on this web site are owned by ITIAML and used under license by ITIAML
            affiliates.

          </li>
          <li>
            You may

          </li>
          <ul class="li-2">
            <li class="pl-2">use and display the materials only on your personal computer only for personal use. ITIAML
              grants you a limited, personal, non-exclusive and non-transferable license only for such use.
            </li>
            <li class="pl-2">print copies of the information on this site for your personal use and store the files on
              your computer for personal use.
            </li>
          </ul>
          <li>You may not
          </li>
          <ul class="li-2">
            <li class="pl-2">
              copy (whether by printing onto paper, storing on disk, downloading or in any other way), distribute
              (including
              distributing copies), download, display, perform, reproduce, distribute, modify, edit, alter, enhance,
              broadcast or tamper with in any way or otherwise use any material contained in the web site except as set
              out
              under "You may". These restrictions apply in relation to all or part of the material on the web site.

            </li>
            <li class="pl-2">
              copy and distribute this information on any other server, or modify or re-use text or graphics on this
              system
              or another system. No reproduction of any part of the web site may be sold or distributed for commercial
              gain
              nor shall it be modified or incorporated in any other work, publication or web site, whether in hard copy
              or
              electronic format, including postings to any other web site.

            </li>
            <li class="pl-2">
              remove any copyright, trade mark or other intellectual property notices contained in the original material
              from any material copied or printed off from the web site; link to this web site; without our express
              written
              consent.

            </li>
          </ul>
        </ul>
      </div>
      <div class="heading-sub2  pt-3 pl-3">
        General Terms and Conditions


      </div>
      <div class="risk-content li-data2">
        <ul>
          <li>ITIAML does not routinely monitor your postings to the web site but reserves the right to do so. However,
            in
            our efforts to promote good citizenship within the Internet community, if ITIAML becomes aware of
            inappropriate use of the web site or any of its Services, ITIAML will respond in any way that, in its sole
            discretion, ITIAML deems appropriate. You acknowledge that ITIAML will have the right to report to law
            enforcement authorities any actions that may be considered illegal, as well as any information it receives
            of
            such illegal conduct. When requested, ITIAML will co-operate fully with law enforcement agencies in any
            investigation of alleged illegal activity on the Internet.
          </li>
          <li>Submissions and unauthorised use of any materials contained on this web site may violate copyright laws,
            trademark laws, the laws of privacy and publicity, certain communications statutes and regulations and other
            applicable laws and regulations. You alone are responsible for your actions or the actions of any person
            using
            your user name and/or password. As such, you shall indemnify and hold ITIAML and its officers, directors,
            employees, affiliates, agents, licensors, and business partners harmless from and against any and all loss,
            costs, damages, liabilities, and expenses (including attorneys' fees) incurred in relation to, arising from,
            or for the purpose of avoiding, any claim or demand from a third party that your use of the web site or the
            use of the web site by any person using your user name and/or password (including without limitation your
            participation in the posting areas or your Submissions) violates any applicable law or regulation, or the
            rights of any third party.
          </li>
          <li>ITIAML reserves the right to terminate access to this web site at any time and without notice. Further
            this
            limited license terminates automatically, without notice to you, if you breach any of these Terms. Upon
            termination, you must immediately destroy any downloaded and printed materials.
          </li>
          <li>ITIAML may change the terms and conditions and disclaimer set out above from time to time. By browsing
            this
            web site you are accepting that you are bound by the current terms and conditions and disclaimer and so you
            should check these each time you revisit the web site.
          </li>
          <li>ITIAML may change the format and content of this web site at any time.
          </li>
          <li>ITIAML may suspend the operation of this web site for support or maintenance work, in order to update the
            content or for any other reason.
          </li>
          <li>Personal details provided to ITIAML through this web site will only be used in accordance with our privacy
            policy. Please read this carefully before going on. By providing your personal details to us you are
            consenting to its use in accordance with our privacy policy.
          </li>
          <li>If you have a question or complaint, please contact us at <a
              href="mailto:mfassist@itiorg.com">mfassist&#64;itiorg.com</a>
          </li>
          <li>ITIAML reserves all other rights.
          </li>
        </ul>
      </div>
      <div class="heading-sub2  pt-3 pl-3">
        Applicable Law and Jurisdiction



      </div>
      <div class="risk-content p-3">
        <p>These terms and conditions are governed by and to be interpreted in accordance with laws of India, without
          regard to the choice or conflicts of law provisions of any jurisdiction. You agree, in the event of any
          dispute arising in relation to these terms and conditions or any dispute arising in relation to the web site
          whether in contract or tort or otherwise, to submit to the jurisdiction of the courts located at Mumbai, India
          for the resolution of all such disputes.

        </p>
      </div>

    </div>

  </div>
  <div class="col-lg-1"></div>
</div>